import { createFileRoute } from '@tanstack/react-router';
import { ReviewEditPage } from './ReviewEditPage';

export const Route = createFileRoute(
  '/_protected/admin/internal-tools/review-receipts/$receiptReviewId/edit/',
)({
  component: ReviewEditPage,
});
